/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Permissions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Hidden from './Hidden/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import VisibilitySelect from './VisibilitySelect/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Permissions({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/Permissions"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Permissions.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceS}
 level="h4"
 text="Permissions"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Use permissions to control who can see your board. For shared boards, you can make them hidden unless subscribed to, meaning they'll only appear in a user's board list if they've been added as a subscriber."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceS}
 weight="medium"
 size="normal"
 text="Visible to"
/>
<VisibilitySelect
  viewPath={`${viewPath}/VisibilitySelect`}
/>
<Hidden
  viewPath={`${viewPath}/Hidden`}
/>
</div>
{children}
</React.Fragment>)
}